import { post } from '../https/request.js'
import Vue from 'vue'
import { Loading } from 'element-ui'

const options = {
  text: '加载中',
  fullscreen: true
}

const showLoading = function () {
  let loadingRequestCount = sessionStorage.getItem('loadingRequestCount')

  if (loadingRequestCount) {
    loadingRequestCount = parseInt(loadingRequestCount)
  }

  if (!loadingRequestCount || loadingRequestCount === 0) {
    // element的服务方式 target 我这边取的是表格 项目是后台系统 每个页面都有表格 类似整个表格loading
    console.log('show loading update')

    Vue.prototype.loadingInstance = Loading.service(options)
  }

  loadingRequestCount++

  sessionStorage.setItem('loadingRequestCount', loadingRequestCount)
}
// 联系我们
export const contactUs = (query) => {
  showLoading()
  return post('/official-website-backend/officialWebsite/contactUs', query)
}

// 计算访问量
export const userAccess = (query) => {
  showLoading()
  return post('/official-website-backend/officialWebsite/userAccess', query)
}



// WEBPACK FOOTER //
// ./src/api/index.js